"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiImageUpload = /** @class */ (function (_super) {
    __extends(ApiImageUpload, _super);
    function ApiImageUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_FILE_LIST = '/api/file/list';
        /**
         * 이미지 upload
         * @param accesstoken
         * @param url
         * @param formData
         * @param cancel
         * @param callback
         * @returns
         */
        _this.uploadImage = function (accesstoken, url, formData) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: url,
                data: formData,
                // cancelToken: cancel.token,
                // progressCallback: callback,
            });
        };
        /**
         * 업로드한 이미지 삭제 api
         * @param accesstoken
         * @param url
         * @param body
         * @returns
         */
        _this.deleteImage = function (accesstoken, url, body) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: url,
                data: body,
            });
        };
        /**
         * upload File List Api
         * @param accesstoken
         * @param data
         * @returns
         */
        _this.getFileList = function (accesstoken, data) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: 'post',
                url: _this.GET_FILE_LIST,
                data: data,
            });
        };
        return _this;
    }
    ApiImageUpload.getInstance = function (initValue) {
        if (!ApiImageUpload.classInstance) {
            this.classInstance = new ApiImageUpload(initValue);
        }
        return this.classInstance;
    };
    return ApiImageUpload;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiImageUpload;
